module.exports = __webpack_public_path__ + "static/media/Rodney-Wilson.29fa5224.png";